<main class="layout">
  <app-server-connectivity-banner></app-server-connectivity-banner>
  <div class="layout-content" [ngSwitch]="isAuthenticated">
    <!-- Loading -->
    <div *ngSwitchCase="'loading'" @fade>
      <app-skeleton-loader></app-skeleton-loader>
    </div>

    <!-- Authenticated -->
    <div *ngSwitchCase="'authenticated'" class="layout-body-wrapper">
      <router-outlet></router-outlet>
    </div>

    <!-- Unauthenticated -->
    <ng-container *ngSwitchCase="'unauthenticated'">
      <router-outlet></router-outlet>
    </ng-container>
  </div>
</main>

<app-notification></app-notification>
<app-pin-entry *ngIf="isVaultLocked" class="fixed inset-0 z-[100]"></app-pin-entry>

<app-vault-setup *ngIf="showVaultSetup" class="fixed inset-0 z-[100]" (close)="onVaultSetupClose()"></app-vault-setup>